import React from "react";
import { Flex, Box, Text } from "@chakra-ui/react";
import { Button } from "ui/button";
import Image from "next/image";

type InlineAdProps = {
  title: string;
  description: string;
  ctaText: string;
  ctaLink: string;
  imageUrl?: string;
  imageAlt?: string;
};

export function InlineAd({ title, description, ctaText, ctaLink, imageUrl, imageAlt }: InlineAdProps) {
  return (
    <Flex
      alignItems={{ base: "center", md: "center" }}
      gap={{ base: "big", md: "bigger" }}
      bg="brand.backgroundSecondary.light"
      borderRadius="base"
      my="biggest"
      px={{ base: "small", md: "big" }}
      py={{ base: "big", md: "bigger" }}
      flexWrap="wrap-reverse"
      justifyContent="space-between"
    >
      <Flex flexDir="column" alignItems="start" minW={{ sm: "380px" }} flex={1}>
        <Text as="h2" textStyle="article.h4" mb="small" mt="0">
          {title}
        </Text>

        <Text textStyle="article.p">{description}</Text>

        <Button hasRightChevron href={ctaLink} target="_blank">
          {ctaText}
        </Button>
      </Flex>

      {imageUrl && (
        <Box borderRadius="tiny" overflow="hidden" mx="auto" flexShrink={0}>
          <Image
            src={`${imageUrl}?w=500`}
            alt={imageAlt ?? ""} // Will be treated as a decorative image if no alt is provided
            width={500}
            height={500}
            style={{
              height: "100%",
              width: "auto",
              maxHeight: "200px",
              maxWidth: "250px",
            }}
          />
        </Box>
      )}
    </Flex>
  );
}
